import React, { useState, useEffect } from "react";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import { Select, Switch, Table } from "antd";
import Loading from "../../components/Common/Loading";
import avatar2 from "../../assets/images/users/profile.png";

function Tools() {
  const [toolList, setToolList] = useState([]);
  const user = useSelector((state) => state.User);
  const [allUsers, setAllUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selected, setSelected] = useState([]);
  const [image, setImage] = useState(null);

  // console.log("err>>>", selected);

  const { Option } = Select;

  const handleChange = (value) => {
    setSelected(value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "tools",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // get tools list
  const getTools = () => {
    setIsLoading(true);
    apiReq(url.GET_ALL_TOOLS + user.user._id, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setToolList(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // * get all users
  const getAllUsers = () => {
    setIsLoading(true);
    apiReq(url.GET_USERS, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setAllUsers(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getAllUsers();
    getTools();
  }, []);

  useEffect(() => {
    if (isOpenModal) {
      setIsSelectAll(false);
    }
  }, [isOpenModal]);

  // Toggle modal
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  // TODO: columns
  const columns = [
    {
      title: "Tool Image",
      dataIndex: "image",
      render: (text, record, index) => (
        <span>
          <img src={record.image} alt={record.title} width="100" />
        </span>
      ),
    },
    {
      title: "Tool Name",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Tool Link",
      dataIndex: "link",
      key: "link",
      sorter: (a, b) => a.link.localeCompare(b.link),
      render: (text, record, index) => (
        <span>
          <a
            href={`${record.link}`}
            target="_blank"
            className="btn btn-primary rounded"
            style={{ whiteSpace: "nowrap" }}
          >
            Open Link{" "}
            <i
              className="ri-arrow-right-up-line"
              style={{ position: "relative", top: 3 }}
            ></i>
          </a>
        </span>
      ),
    },
    {
      title: "Team",
      dataIndex: "team",
      key: "team",
      render: (text, record, index) => (
        <div>
          {record.users.length > 0 ? (
            <div className="users_group">
              {record.users.map((user, index) => {
                return (
                  <div className="user_avatar" key={index}>
                    <img
                      src={user.image ? user.image : avatar2}
                      alt={user.name}
                      title={user.name}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            "NA"
          )}
        </div>
      ),
    },
    {
      title: "Tool Description",
      dataIndex: "description",
      key: "description",
      render: (text, record, index) => <span>{record.description}</span>,
    },
    {
      title: "Date",
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          {user?.user?.role.title === "Admin" && (
            <>
              <button
                className="btn btn-success btn-sm mr-2"
                onClick={() => handleEdit(record)}
              >
                <i className="ri-pencil-line"></i>
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              {user.user?._id !== record._id ? (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(record._id)}
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              ) : (
                <button
                  className="btn btn-danger btn-sm"
                  style={{ opacity: 0.5 }}
                  onClick={() => {
                    Swal.fire({
                      title: "Oops...",
                      text: "You can not delete your own account",
                      icon: "error",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }}
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              )}
            </>
          )}
        </div>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "<Strong>Are you absolutely sure?</Strong>",
      html: "Please type <Strong>DELETE</Strong> to confirm.",
      input: "text",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === "DELETE") {
          apiReq(url.DELETE_TOOL + id, {}, "delete", {
            Authorization: `Bearer ${user.user?.token}`,
          })
            .then((res) => {
              if (res.success) {
                Swal.fire({
                  title: "Deleted!",
                  text: res.message,
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                getTools();
              }
            })
            .catch((err) => {
              console.log("err>>>", err);
            });
        } else {
          Swal.fire({
            title: "Cancelled",
            text: "Your data is safe :)",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    });
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (selectedItem === null) {
      setIsLoading(true);
      apiReq(
        url.CREATE_TOOL,
        {
          title: data.title,
          description: data.description,
          link: data.link,
          users: selected,
          image,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getTools();
            setIsOpenModal(false);
            setSelectedItem(null);
            setIsLoading(false);
            setSelected([]);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_TOOL + selectedItem._id,
        {
          title: data.title,
          description: data.description,
          link: data.link,
          users: selected,
          image,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getTools();
            setIsOpenModal(false);
            setSelectedItem(null);
            setIsLoading(false);
            setSelected([]);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Handle edit category
  const handleEdit = (item) => {
    setSelectedItem(item);
    setValue("title", item.title);
    setValue("description", item.description);
    setValue("link", item.link);
    setSelected(item.users.map((user) => user._id));
    setIsOpenModal(true);
    setImage(item.image);
  };

  // onChangeSelectAll
  const onChangeSelectAll = (value) => {
    if (value) {
      setSelected([]);
      setSelected(allUsers.map((user) => user._id));
      setIsSelectAll(value);
    } else {
      setSelected([]);
      setIsSelectAll(value);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Modal toggle={toggleModal} isOpen={isOpenModal} size="lg">
          <ModalHeader>
            {selectedItem !== null ? "Update tool information" : "Add new tool"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label>Image</label>
                    <div
                      className="dropzone p-4 mb-3"
                      style={{ minHeight: 120 }}
                    >
                      {!image ? (
                        <div
                          className="needsclick"
                          // {...getRootProps()}
                        >
                          {/* <input /> */}
                          <div className="mb-3">
                            <i className="ri-image-line display-4 text-muted"></i>
                          </div>
                          <h5 className="opacity-40">Tool Image</h5>
                          <input
                            type="file"
                            className="image_upload_input"
                            onChange={(e) => handleLogoUpload(e)}
                          />
                        </div>
                      ) : (
                        <div className="filled_image">
                          <img src={image} alt="image" className="img-fluid" />
                          <div
                            className="remove_image"
                            onClick={() => setImage(null)}
                          >
                            <i className="mdi mdi-close-thick"></i>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <label>Tool Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter tool name"
                  {...register("title", { required: true })}
                />
                {errors.title && (
                  <span className="text-danger">Tool Name is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Tool Link</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="https://..."
                  {...register("link", {
                    required: true,
                  })}
                />
                {errors.link && (
                  <span className="text-danger">Tool Link is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Tool Description</label>
                <textarea
                  className="form-control"
                  placeholder="Enter tool description"
                  {...register("description", {
                    required: true,
                  })}
                />
                {errors.description && (
                  <span className="text-danger">
                    Tool description is required
                  </span>
                )}
              </div>
              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <label>Employees</label>
                  <label>
                    <span
                      className="text-muted mr-4 d-inline-block"
                      style={{ marginRight: 10 }}
                    >
                      Select All
                    </span>
                    <Switch value={isSelectAll} onChange={onChangeSelectAll} />
                  </label>
                </div>
                <Select
                  mode="multiple"
                  style={{
                    width: "100%",
                  }}
                  placeholder="select employees"
                  value={selected}
                  onChange={handleChange}
                  optionLabelProp="label"
                  disabled={isSelectAll}
                >
                  {allUsers.map((item, index) => (
                    <Option value={item._id} label={item.name} key={index}>
                      <div className="demo-option-label-item">
                        {item.name} ({item.email})
                      </div>
                    </Option>
                  ))}
                </Select>
              </div>

              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggleModal}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Tools</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    {user?.user?.role.title === "Admin" && (
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setIsOpenModal(!isOpenModal);
                          setImage(null);
                          reset();
                        }}
                      >
                        Add new tool
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <hr />
              <Table
                columns={columns}
                dataSource={toolList}
                bordered
                loading={isLoading}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Tools;
